// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__PcZWY","inputWrap":"CustomTip_inputWrap__1RNSq"};